import { useState, useEffect } from 'react';
import { Field } from '../../../components/Field.jsx';

export default function StockDashboardFilters({ value, onApply }) {
  const [filters, setFilters] = useState({ desde: '', hasta: '' });

  useEffect(() => {
    if (value) {
      setFilters((prev) => ({ ...prev, ...value }));
    }
  }, [value]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onApply?.(filters);
  };

  return (
    <form onSubmit={handleSubmit} className="grid grid-cols-12 gap-4">
      <Field label="Desde" className="col-span-12 md:col-span-3">
        <input
          type="date"
          value={filters.desde}
          onChange={(event) => setFilters((prev) => ({ ...prev, desde: event.target.value }))}
          className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
        />
      </Field>
      <Field label="Hasta" className="col-span-12 md:col-span-3">
        <input
          type="date"
          value={filters.hasta}
          onChange={(event) => setFilters((prev) => ({ ...prev, hasta: event.target.value }))}
          className="w-full rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.85)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
        />
      </Field>
      <div className="col-span-12 flex items-end justify-end">
        <button
          type="submit"
          className="rounded-xl bg-[rgb(var(--brand))] px-6 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[rgba(var(--brand-700),0.9)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
        >
          Actualizar
        </button>
      </div>
    </form>
  );
}
